import api from '../api';

const baseContext = `${process.env.REACT_APP_API_URL_LOCAL}/api/v1/worker/config`;

const getCities = () => {
  return api.get(`${baseContext}/cities`);
};
const getEducationsLevels = () => {
  return api.get(`${baseContext}/educations`);
};
const getDocumentsTypes = () => {
  return api.get(`${baseContext}/documents`);
};

export { getCities, getEducationsLevels, getDocumentsTypes };
